import React, {Component} from 'react';
import {attempCreateSalaryAdjust} from 'actions/UserActions';

class SalaryCreateRow extends Component {
  constructor(props) {
    super(props);
    let {adjustmentTypeList} = this.props;

    this.initState={
      amount: "",
      typeID: adjustmentTypeList.get(0).get('id'),
      note: "",
      creating: false
    }
    this.state = this.initState;
  }

  handleChange = (e) => {
    let {name, value} = e.target;

    this.setState({
      [name]: value
    })
  }

  handleSelect = (e) => {
    this.setState({
      typeID: parseInt(e.target.value, 10)
    })
  }

  finishCreate = () => {
    this.setState(this.initState);
  }

  handleCreate = () => {
    let {amount, typeID, note} = this.state;
    if (isNaN(parseInt(amount, 10))) return;
    this.setState({creating: true});
    this.props.dispatch(attempCreateSalaryAdjust(amount, typeID, note, this.finishCreate));
  }

  render() {
    let {typeID} = this.state;
    let {adjustmentTypeList} = this.props;
    return (
      <tr>
        <td className="salary__modal__table__amount">
          <input
            className="form-control"
            name="amount"
            placeholder="金額"
            value={this.state.amount}
            onChange={this.handleChange}
            disabled={this.state.creating} />
        </td>
        <td className="salary__modal__table__type">
          <select
            className="form-control"
            value={typeID}
            onChange={this.handleSelect}
            disabled={this.state.creating} >
            {adjustmentTypeList.map(adjustment=>
              <option value={adjustment.get('id')}>{adjustment.get('name')}</option>
            )}
          </select>
        </td>
        <td className="salary__modal__table__notes">
          <input 
            className="form-control"
            name="note"
            placeholder="備註"
            value={this.state.note}
            onChange={this.handleChange}
            disabled={this.state.creating} />
        </td>
        <td>
          <button
            className="btn btn-primary create-btn"
            onClick={this.handleCreate}
            disabled={this.state.creating}
          >
            新增
          </button>
        </td>
      </tr>
    )
  }
}

export default SalaryCreateRow;



// WEBPACK FOOTER //
// ./src/components/Salary/SalaryCreateRow.js